import type {CreatePaymentMethodKlarnaData} from '@stripe/stripe-js';
import {AbstractStripePayment, type ConfirmResult, type TokenResult} from './abstract/class-abstract-stripe-payment';
import {billingDetails} from './stripe';

class StripeKlarnaPayment extends AbstractStripePayment {
	public gatewayId(): string {
		return 'peachpay_stripe_klarna';
	}

	public async tokenize(): Promise<TokenResult> {
		const {paymentMethod, error} = await this.stripe.createPaymentMethod({
			type: 'klarna',
			billing_details: billingDetails(),
		} as CreatePaymentMethodKlarnaData);

		if (error) {
			const message = error.message ?? 'Failed to tokenize payment method.';

			return [null, {
				paymentStatus: 'creationfailed',
				note: message,
			}];
		}

		if (!paymentMethod?.id) {
			return [null, {
				paymentStatus: 'creationfailed',
				note: 'Failed to tokenize payment method.',
			}];
		}

		return [paymentMethod.id, {}];
	}

	public async confirm(clientSecret: string, intermediateURL?: string | undefined): Promise<ConfirmResult> {
		const {paymentIntent, error} = await this.stripe.confirmKlarnaPayment(clientSecret, {return_url: intermediateURL});

		if (error) {
			const message = error.message ?? 'Failed to confirm payment.';
			return [null, {
				note: message,
			}];
		}

		if (paymentIntent) {
			return ['success', {}];
		}

		return [null, {}];
	}
}

export {
	StripeKlarnaPayment,
};
